import { Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import CommitStatusFactory from '../factories/CommitStatusFactory';
export default function CommitStatus(props) {
    const { entity, processingPercentage = 100, isPullRequest = false, loading = false, } = props;
    const percentage = processingPercentage > 20 ? processingPercentage : 20;
    const commit = isPullRequest ? entity.sourceCommit : entity;
    if (!commit) {
        return null;
    }
    const commitStatus = CommitStatusFactory.createInstance(commit);
    const issueCount = commit.getIssuesCount();
    const diffCount = commit.getDiffCount();
    return _jsxs(_Fragment, { children: [commitStatus.renderLoading(isPullRequest, percentage), commitStatus.renderCounter(issueCount, diffCount), commitStatus.renderStatusBadge(commit.options, commit.errorCount, commit.warningCount, commit.isDone(), commit.isTimedOut(), commit.isMeetingThresholds(), loading), commitStatus.renderQuickFixes(Number(commit.fixFilesCount))] });
}
